module.exports = __webpack_public_path__ + "img/close.83f2e784.svg";